<template>
  <ConnectionEntrance v-if="couldVisibleEntrance" />
</template>

<script>
import ConnectionEntrance from '@/components/Pages/Connections/Entrance/Entrance.vue'

import CharacterMetaMixins from '@/mixins/CharacterMetaMixins.js'

export default {
  components : {
    ConnectionEntrance
  },

  mixins : [
    CharacterMetaMixins
  ],

  data(){
    return {
      couldVisibleEntrance  : false
    };
  },

  watch : {
    characterMetaData : {
      handler(data){
        if(data === {}) return;

        this.checkCouldVisibleEntrance();
      },
      deep: true
    },

    isMountedLoginedPage : {
      handler(){
        this.checkCouldVisibleEntrance();
      }
    }
  },

  methods : {
    checkCouldVisibleEntrance(){
      if(this.isMountedLoginedPage === false) return;
      if(this.characterMetaData === {}) return;

      let couldShowEntrance = false;

      if(typeof this.characterMetaData['connections.showEntrance'] !== 'undefined'){
        couldShowEntrance = this.characterMetaData['connections.showEntrance'];
      }
      
      if(couldShowEntrance === true){
        this.couldVisibleEntrance = true;
      }else{
        this.$router.push({
          name    : 'connections.room',
          params  : {
            roomType : 'public'
          }
        });

        this.$nextTick(() => {
          this.$parent.$emit('mountedPage');
        });
      }
    }
  }
}
</script>